/* cro-cart.js (r11 2026-09-26; r2 2026-09-24) — the custom cart drawer's only client logic. Event-driven, ZERO polling.
 *
 *  - Shims every UpCart global that other theme scripts still call (upcartOpenCart, UpcartToggleCart,
 *    upcartRefreshCart, upcartSubscribe*, upcartDocumentOrShadowRoot), so nothing breaks with UpCart off.
 *  - Free-gift engine: the free sticker on every non-empty cart; the bracelet 3-pack at $55 and up
 *    (removed again below $55). Reads its state from data attributes that cart-form.liquid renders on
 *    form#cart, so it never has to fetch /cart.js to decide. A hand-removed bracelet is remembered for
 *    the session so it is not re-added.
 *  - Protection toggle, split-shipment toggle, and cleanup of stale / duplicate split fees (the server
 *    marks them; this just removes the line).
 *  - Drawer recommendations: own loader, keyed on the first REAL item (never a gift). Prefetched on
 *    product pages for the product on screen, and kept while that product stays in the cart, so adding
 *    an upsell never reshuffles the list under the shopper's thumb.
 *  - Express (wallet) buttons are mounted ONCE from an inert <template> the first time the drawer is
 *    about to show: keeps Shopify's 150-request checkout prefetch off every page load, and the element
 *    is never re-inserted afterwards (a re-inserted shopify-accelerated-checkout-cart never repaints).
 *  - Optimistic open: the drawer shows the instant an add is submitted (PDP form, sticky bar, quick-add)
 *    with a progress bar until the theme's own add flow re-renders it.
 *  - Header cart icon opens the drawer.
 *  Everything runs off one signal: the theme re-renders #AjaxCartForm after every add / change /
 *  refresh, and a MutationObserver on it fires the engine. silentRefresh() re-renders WITHOUT opening
 *  the drawer (so a page-load gift add never pops the cart open). No emojis.
 */
(function(){
  if (window.__fstCartInit) return; window.__fstCartInit = true;

  var STICKER = 53258740924700, BRACELET = 54517456339228, BRACELET_AT = 5500;
  var SKIP_KEY = 'fst_gift_skip';
  var busy = false, addFails = 0;

  function q(s, r){ return (r || document).querySelector(s); }
  function form(){ return document.getElementById('cart'); }
  function drawer(){ return document.getElementById('site-cart-sidebar'); }
  function scroller(){ var d = drawer(); return d ? d.querySelector('.sidebar__content') : null; }
  function skipped(){ try { return sessionStorage.getItem(SKIP_KEY) === '1'; } catch(e){ return false; } }
  function post(url, body){
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(body) })
      .then(function(r){ return r.json(); });
  }

  // ---- ONE round trip per cart change (2026-09-24, "still a bit laggy") ----
  // Every POST to /cart/add.js or /cart/change.js gets `sections: helper-cart`, so Shopify returns the re-rendered
  // cart inside the same response. That HTML is cached for 2s, and the follow-up GET ?section_id=helper-cart that the
  // theme (and silentRefresh) makes is answered from the cache with no network. Add requests also carry the free
  // sticker when the cart has none yet, so a first add is one request instead of three. Bodies the theme sends as
  // form-encoded are converted to the JSON items format (same endpoint, same 422 shape on failure).
  var sectionCache = { html: '', at: 0 };
  function remember(j){ if (j && j.sections && typeof j.sections['helper-cart'] === 'string'){ sectionCache = { html: j.sections['helper-cart'], at: Date.now() }; } return j; }
  function needsSticker(){ var f = form(); return !!f && f.dataset && f.dataset.fstHasSticker === '0'; }
  function stickerItem(){ return { id: STICKER, quantity: 1, properties: { '_free_gift': 'Free sticker' } }; }
  function braceletItem(){ return { id: BRACELET, quantity: 1, properties: { '_free_gift': 'Free bracelet 3 pack ($55+)' } }; }
  // Price of a variant as far as this page knows it (product page `meta`, or a card / upsell row's variants JSON with
  // prices). Unknown = null, and the gift engine's post-render pass handles the bracelet instead.
  function priceOf(vid){
    vid = +vid;
    try { var mv = window.meta && window.meta.product && window.meta.product.variants; if (mv){ for (var i = 0; i < mv.length; i++){ if (+mv[i].id === vid && typeof mv[i].price === 'number') return mv[i].price; } } } catch(e){}
    var scripts = document.querySelectorAll('script[data-cpc-variants]');
    for (var j = 0; j < scripts.length; j++){ try { var arr = JSON.parse(scripts[j].textContent); for (var k = 0; k < arr.length; k++){ if (+arr[k].id === vid && typeof arr[k].p === 'number') return arr[k].p; } } catch(e){} }
    return null;
  }
  // The bracelet rides along in the same add when this page can see that the cart is about to cross $55.
  function braceletRidesAlong(items){
    var f = form(); if (!f || !f.dataset || f.dataset.fstHasBracelet === '1' || skipped()) return false;
    var total = parseInt(f.dataset.fstRealTotal, 10) || 0;
    for (var i = 0; i < items.length; i++){
      var it = items[i]; if (+it.id === STICKER || +it.id === BRACELET) continue;
      var pr = priceOf(it.id); if (pr === null) return false;
      total += pr * (parseInt(it.quantity, 10) || 1);
    }
    return total >= BRACELET_AT;
  }
  function headerOf(h, name){ if (!h) return ''; if (typeof h.get === 'function') return h.get(name) || ''; var k = Object.keys(h).filter(function(x){ return x.toLowerCase() === name.toLowerCase(); })[0]; return k ? h[k] : ''; }
  function setHeader(init, name, value){ if (init.headers && typeof init.headers.set === 'function'){ init.headers.set(name, value); return; } init.headers = init.headers || {}; Object.keys(init.headers).forEach(function(k){ if (k.toLowerCase() === name.toLowerCase()) delete init.headers[k]; }); init.headers[name] = value; }
  function formToItems(str){
    var sp = new URLSearchParams(str), item = { quantity: 1, properties: {} }, hasProps = false;
    sp.forEach(function(v, k){
      if (k === 'id') item.id = parseInt(v, 10);
      else if (k === 'quantity') item.quantity = parseInt(v, 10) || 1;
      else if (k === 'selling_plan' && v) item.selling_plan = parseInt(v, 10);
      else { var m = k.match(/^properties\[(.+)\]$/); if (m){ item.properties[m[1]] = v; hasProps = true; } }
    });
    if (!hasProps) delete item.properties;
    return item.id ? [item] : null;
  }
  if (!window.__fstCartFetch){
    window.__fstCartFetch = true;
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      try {
        var url = (typeof input === 'string') ? input : ((input && input.url) || '');
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        var path = url.split('?')[0];
        if (method === 'GET' && url.indexOf('section_id=helper-cart') > -1 && sectionCache.html && (Date.now() - sectionCache.at) < 2000){
          return Promise.resolve(new Response(sectionCache.html, { status: 200, headers: { 'Content-Type': 'text/html' } }));
        }
        var isAdd = /\/cart\/add(\.js)?$/.test(path), isChange = /\/cart\/change(\.js)?$/.test(path);
        if (method === 'POST' && (isAdd || isChange) && init && init.body != null){
          var b = init.body, ct = String(headerOf(init.headers, 'Content-Type')).toLowerCase(), payload = null;
          if (typeof b === 'string' && (ct.indexOf('json') > -1 || /^\s*\{/.test(b))){ try { payload = JSON.parse(b); } catch(e){ payload = null; } }
          else if (typeof b === 'string' && isAdd){ var its = formToItems(b); if (its) payload = { items: its }; }
          if (payload){
            if (isAdd){
              if (!payload.items && payload.id) payload = { items: [{ id: payload.id, quantity: payload.quantity || 1, properties: payload.properties }] };
              if (payload.items){
                if (needsSticker() && !payload.items.some(function(i){ return +i.id === STICKER; })) payload.items.push(stickerItem());
                if (braceletRidesAlong(payload.items) && !payload.items.some(function(i){ return +i.id === BRACELET; })) payload.items.push(braceletItem());
              }
            }
            payload.sections = 'helper-cart';
            init.body = JSON.stringify(payload);
            setHeader(init, 'Content-Type', 'application/json');
            setHeader(init, 'Accept', 'application/json');
          } else if (typeof b === 'string' && b.indexOf('sections=') === -1){
            init.body = b + (b ? '&' : '') + 'sections=helper-cart';
          }
          return _fetch.call(this, input, init).then(function(res){
            var oj = res.json.bind(res);
            res.json = function(){ return oj().then(remember); };
            return res;
          });
        }
      } catch(e){}
      return _fetch.apply(this, arguments);
    };
  }

  // ---- express (wallet) buttons: mounted on demand from an inert <template>, MINUS the wallets Caleb
  // wants out of the cart (2026-09-24: Amazon Pay; it stays available on the checkout page).
  // The element renders in a closed shadow root, so the only reliable way to drop a wallet is to remove it
  // from `wallet-configs` before the element connects. Each template is consumed once.
  var HIDE_IN_CART = /amazon/i;  // 2026-09-24: Caleb wants PayPal back in the cart; Amazon Pay stays checkout-only
  function mountExpress(){
    document.querySelectorAll('template[data-fst-express-tpl]').forEach(function(tpl){
      var host = (tpl.previousElementSibling && tpl.previousElementSibling.hasAttribute('data-fst-express-host')) ? tpl.previousElementSibling : q('[data-fst-express-host]');
      if (!host) return;
      var frag = tpl.content.cloneNode(true);
      var el = frag.querySelector('shopify-accelerated-checkout-cart');
      if (el){
        try {
          var cfg = JSON.parse(el.getAttribute('wallet-configs') || '[]');
          var keep = cfg.filter(function(w){ return !HIDE_IN_CART.test((w && w.name) || ''); });
          if (!keep.length) frag = null;
          else if (keep.length !== cfg.length) el.setAttribute('wallet-configs', JSON.stringify(keep));
        } catch(e){}
      }
      if (frag) host.appendChild(frag);
      if (tpl.parentNode) tpl.parentNode.removeChild(tpl);
      var mounted = host.querySelector('shopify-accelerated-checkout-cart');
      if (mounted) fitExpress(mounted);
    });
  }
  // The wallet element keeps rows for wallets that never render on this device (e.g. a reserved Apple Pay or Google Pay
  // row), which left a tall blank gap under the last button "sometimes" (Caleb's iPhone screenshot, 2026-09-29; measured
  // 208px for 2 buttons). The buttons are light-DOM children, so trim the element to the bottom of the last one that is
  // actually showing, and re-trim whenever a wallet appears late or the element changes size. The skeleton phase (one
  // placeholder div) is left alone.
  function fitExpress(el){
    if (!el || el.__fstFit) return; el.__fstFit = true;
    var busy = false;
    function fit(){
      if (busy) return; busy = true;
      try {
        var kids = [].slice.call(el.children).filter(function(c){
          if (getComputedStyle(c).display === 'none') return false;
          return c.getBoundingClientRect().height > 1;
        });
        var buttons = kids.filter(function(c){ return c.tagName.indexOf('-') > -1; });  // custom elements = real wallet buttons
        if (!buttons.length){ if (el.style.height) el.style.height = ''; if (el.style.overflow) el.style.overflow = ''; return; }
        var top = el.getBoundingClientRect().top, bottom = 0;
        buttons.forEach(function(c){ var r = c.getBoundingClientRect(); if (r.height > 1) bottom = Math.max(bottom, r.bottom - top); });
        if (bottom > 0){
          var h = Math.ceil(bottom) + 'px';
          if (el.style.display !== 'block') el.style.display = 'block';
          if (el.style.overflow !== 'hidden') el.style.overflow = 'hidden';
          if (el.style.height !== h) el.style.height = h;
        }
      } catch(e){}
      finally { busy = false; }
    }
    function later(){ requestAnimationFrame ? requestAnimationFrame(fit) : setTimeout(fit, 16); }
    if (window.MutationObserver) new MutationObserver(later).observe(el, { childList: true, subtree: false, attributes: true, attributeFilter: ['style', 'class', 'hidden'] });
    if (window.ResizeObserver){
      var ro = new ResizeObserver(later);
      var watchKids = function(){ [].forEach.call(el.children, function(c){ try { ro.observe(c); } catch(e){} }); };
      watchKids();
      if (window.MutationObserver) new MutationObserver(watchKids).observe(el, { childList: true });
    }
    [300, 1200, 3000, 6000].forEach(function(ms){ setTimeout(fit, ms); });  // wallets render asynchronously
    fitExpress.refit = fit;
  }

  // Re-render the cart from the server WITHOUT opening the drawer. One in flight at a time; a call made
  // while one is running queues exactly one more (so a refresh asked for after a newer cart change is
  // never served the older response). `lastRefresh` powers the cooldown that keeps other scripts'
  // reactions to our refresh (they re-fetch /cart.js and re-dispatch cart events) from re-triggering us.
  var inflight = null, again = false, lastRefresh = 0;
  function silentRefresh(){
    if (inflight){ again = true; return inflight; }
    inflight = fetch('?section_id=helper-cart', { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(text){
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var nf = doc.getElementById('AjaxCartForm'), ns = doc.getElementById('AjaxCartSubtotal');
        var af = document.getElementById('AjaxCartForm'), as = document.getElementById('AjaxCartSubtotal');
        // r11: iOS freezes a scroll container when the focused element inside it is replaced mid-gesture (the protection
        // switch lives in the footer we are about to swap), and can drop the scroll position when the content height dips
        // for a frame. Blur first, remember the scroll offset, swap, restore.
        var sc = scroller(), keep = sc ? sc.scrollTop : 0;
        try { var ae = document.activeElement; if (ae && ae !== document.body && (af && af.contains(ae) || as && as.contains(ae))) ae.blur(); } catch(e){}
        if (af && nf){ af.innerHTML = nf.innerHTML; if (typeof af.ajaxifyCartItems === 'function') af.ajaxifyCartItems(); }
        if (as && ns){ as.innerHTML = ns.innerHTML; }
        if (sc && keep && sc.scrollTop !== keep) sc.scrollTop = Math.min(keep, Math.max(0, sc.scrollHeight - sc.clientHeight));
        syncBadges();
        // detail.fst marks our own event so the generic 'cart:refresh' listener below ignores it (no refresh loop)
        try { document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { fst: true } })); } catch(e){}
      })
      .catch(function(){})
      .then(function(){ inflight = null; lastRefresh = Date.now(); if (again){ again = false; return silentRefresh(); } });
    return inflight;
  }
  function syncBadges(){
    // r7: every count the shopper sees is the PAID item count (form#cart data-fst-real-count): free gifts, the protection
    // line and the split fee never inflate it. component-cart.js writes cart.item_count into [data-header-cart-count] on its
    // own updates; this runs right after and corrects it.
    var c = q('#AjaxCartForm [data-cart-count]'); if (!c) return;
    var f = form(), n = (f && f.dataset.fstRealCount != null) ? String(f.dataset.fstRealCount) : c.textContent.trim();
    document.querySelectorAll('[data-fst-head-count], [data-header-cart-count]').forEach(function(el){ el.textContent = n; });
    document.querySelectorAll('[data-hv-cart-count]').forEach(function(el){ el.textContent = n; if (n === '0') el.setAttribute('hidden', ''); else el.removeAttribute('hidden'); });
  }
  var addingTimer = null;
  function showDrawer(adding){
    var d = drawer(); if (!d) return;
    mountExpress();
    // the trust banner + reviewer photos are lazy (no page-load cost while the drawer is hidden); fetch them now
    d.querySelectorAll('img[loading="lazy"]').forEach(function(im){ im.loading = 'eager'; });
    if (adding){
      d.classList.add('is-adding');
      clearTimeout(addingTimer); addingTimer = setTimeout(function(){ d.classList.remove('is-adding'); }, 6000);
    }
    if (typeof d.show === 'function' && !d.classList.contains('sidebar--opened')) d.show();
    warmCheckout(); setTimeout(guardGeometry, 450);
  }
  // iOS rewrites the theme's :root --sidebar-width from window.innerWidth on every resize (toolbar collapse, zoom): re-check then
  var geoTimer = null;
  function geoSoon(){ clearTimeout(geoTimer); geoTimer = setTimeout(guardGeometry, 120); }
  window.addEventListener('resize', geoSoon);
  window.addEventListener('orientationchange', geoSoon);
  if (window.visualViewport) window.visualViewport.addEventListener('resize', geoSoon);
  // Every checkout entry (POST /cart or GET /checkout) bounces through shop.app (Shop Pay's universal redirect) before the
  // checkout page loads; opening the connection while the shopper reads the cart takes the DNS + TLS cost off the tap.
  var warmed = false;
  function warmCheckout(){
    // the deferred Shopify checkout pre-fetch (see layout/theme.liquid) starts the moment a shopper opens the cart
    try { if (window.fstLoadCheckoutPreloads) window.fstLoadCheckoutPreloads(); } catch(e){}
    if (warmed) return; warmed = true;
    ['https://shop.app', 'https://cdn.shopify.com'].forEach(function(h){
      var l = document.createElement('link'); l.rel = 'preconnect'; l.href = h; document.head.appendChild(l);
    });
  }
  function openDrawer(){ showDrawer(false); silentRefresh(); }

  // ---- UpCart shims ----
  window.upcartOpenCart = openDrawer;
  window.UpcartToggleCart = openDrawer;
  window.upcartRefreshCart = silentRefresh;
  window.upcartDocumentOrShadowRoot = document;
  window.upcart = window.upcart || {}; window.upcart.refreshCart = silentRefresh;
  var subs = { loaded: [], removed: [], opened: [] };
  window.upcartSubscribeCartLoaded = function(fn){ if (typeof fn === 'function') subs.loaded.push(fn); };
  window.upcartSubscribeItemRemoved = function(fn){ if (typeof fn === 'function') subs.removed.push(fn); };
  window.upcartSubscribeCartOpened = function(fn){ if (typeof fn === 'function') subs.opened.push(fn); };
  function fire(list){ for (var i = 0; i < list.length; i++){ try { list[i](); } catch(e){} } }

  // ---- free-gift engine ----
  function giftEngine(){
    var f = form(); if (!f || busy || addFails >= 3) return;
    var d = f.dataset;
    var real = parseInt(d.fstRealTotal, 10) || 0, realN = parseInt(d.fstRealCount, 10) || 0;
    var hasS = d.fstHasSticker === '1', hasB = d.fstHasBracelet === '1';
    var sKey = d.fstStickerKey || '', bKey = d.fstBraceletKey || '';
    var sQty = parseInt(d.fstStickerQty, 10) || 0, bQty = parseInt(d.fstBraceletQty, 10) || 0;
    var todo = null, adds = [];
    // free items are one per order: anyone bumping the quantity (or adding the $0 product by URL) gets it pinned back to 1
    if (hasS && sKey && sQty > 1){ todo = { set: sKey }; }
    else if (hasB && bKey && bQty > 1){ todo = { set: bKey }; }
    else {
      if (realN > 0 && !hasS) adds.push(stickerItem());
      if (real >= BRACELET_AT && !hasB && !skipped()) adds.push({ id: BRACELET, quantity: 1, properties: { '_free_gift': 'Free bracelet 3 pack ($55+)' } });
      if (adds.length){ todo = { addItems: adds }; }
      else if (realN === 0 && hasS && sKey){ todo = { remove: sKey }; }
      else if (real < BRACELET_AT && hasB && bKey){ todo = { remove: bKey }; try { sessionStorage.removeItem(SKIP_KEY); } catch(e){} }
    }
    if (!todo) return;
    busy = true;
    var p = todo.addItems
      ? post('/cart/add.js', { items: todo.addItems })
      : todo.set
        ? post('/cart/change.js', { id: todo.set, quantity: 1 })
        : post('/cart/change.js', { id: todo.remove, quantity: 0 });
    p.then(function(j){ if (j && j.status && j.status !== 200) addFails++; else addFails = 0; })
     .catch(function(){ addFails++; })
     .then(function(){ busy = false; silentRefresh(); });
  }

  // ---- protection + split toggles ----
  document.addEventListener('change', function(e){
    var t = e.target; if (!t || !t.classList) return;
    if (t.classList.contains('fst-prot-cb')){
      var prot = t.closest('[data-fst-prot]'); if (!prot) return;
      try { t.blur(); } catch(e){}
      var on = t.checked, key = prot.getAttribute('data-key'), vid = parseInt(prot.getAttribute('data-vid'), 10);
      prot.classList.toggle('is-on', on); busy = true;
      (on ? post('/cart/add.js', { items: [{ id: vid, quantity: 1 }] }) : post('/cart/change.js', { id: key, quantity: 0 }))
        .catch(function(){}).then(function(){ busy = false; silentRefresh(); });
      return;
    }
    if (t.classList.contains('fst-split-cb')){
      var sp = t.closest('[data-fst-split]'); if (!sp) return;
      try { t.blur(); } catch(e){}
      var want = t.checked, fkey = sp.getAttribute('data-fee-key') || '', fvid = sp.getAttribute('data-fee-vid') || '', fin = sp.getAttribute('data-fee-in') || '';
      busy = true;
      var chain = Promise.resolve();
      if (fkey && (!want || fvid !== fin)) chain = chain.then(function(){ return post('/cart/change.js', { id: fkey, quantity: 0 }); });
      if (want && (fvid !== fin || !fkey)) chain = chain.then(function(){ return post('/cart/add.js', { items: [{ id: parseInt(fvid, 10), quantity: 1, properties: { '_split_shipment': 'Ship in-stock items first' } }] }); });
      chain.catch(function(){}).then(function(){ busy = false; silentRefresh(); });
    }
  }, true);

  // stale (no longer eligible) or duplicate split-fee lines: the server marks them, we remove them
  function feeCleanup(){
    if (busy) return;
    var m = q('[data-fst-split-stale]') || q('[data-fst-fee-extra]'); if (!m) return;
    var key = m.getAttribute('data-key'); if (!key) return;
    busy = true;
    post('/cart/change.js', { id: key, quantity: 0 }).catch(function(){}).then(function(){ busy = false; silentRefresh(); });
  }

  // hand-removed bracelet at $55+: remember for this session; header cart icon: open the drawer
  document.addEventListener('click', function(e){
    var t = e.target; if (!t || !t.closest) return;
    // "i" on the protection row: opens the explanation without flipping the switch (it sits inside the <label>)
    var info = t.closest('[data-fst-prot-info]');
    if (info){
      e.preventDefault(); e.stopPropagation();
      var more = q('[data-fst-prot-more]'); if (!more) return;
      var open = more.hidden; more.hidden = !open; info.setAttribute('aria-expanded', open ? 'true' : 'false');
      return;
    }
    if (t.closest('.fst-gift-remove')){ try { sessionStorage.setItem(SKIP_KEY, '1'); } catch(err){} fire(subs.removed); return; }
    var co = t.closest('#CheckOut');
    if (co){
      // r10: the theme's path POSTs the whole cart form (quantities again) and then redirects; GET /checkout skips that
      // round trip. Wait for any change still in flight so nothing typed a second ago is lost, then go. The button stays a
      // real submit button, so without JS the form path still works.
      e.preventDefault();
      if (co.classList.contains('is-going')) return;
      co.classList.add('is-going');
      var started = Date.now();
      (function go(){
        var f = form(), pending = busy || inflight || (f && f.classList.contains('processing'));
        if (pending && Date.now() - started < 2500){ setTimeout(go, 60); return; }
        window.location.href = '/checkout';
      })();
      return;
    }
    var ico = t.closest('.hv-cart, [data-fst-open-cart]');
    if (ico && drawer()){ e.preventDefault(); openDrawer(); }
  }, true);

  // ---- recommendations ----
  var recsFor = '';
  function fetchRecs(pid){
    var box = q('[data-fst-recs]'); if (!box || !pid) return;
    recsFor = pid;
    var base = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.product_recommendations_url) || '/recommendations/products';
    fetch(base + '?section_id=' + (box.getAttribute('data-section') || 'cro-cart-recs') + '&product_id=' + pid + '&limit=' + (box.getAttribute('data-limit') || '6'), { credentials: 'same-origin' })
      .then(function(r){ return r.text(); })
      .then(function(html){
        if (recsFor !== pid) return;  // superseded by a newer request
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var inner = doc.querySelector('[data-fst-recs-performed]');
        box.innerHTML = (inner && inner.querySelector('[data-js-product-item]')) ? inner.innerHTML : '';
        hideRecsInCart();
      })
      .catch(function(){});
  }
  function paintRecChips(){
    // first paint of the pre-order dots + the "Dotted sizes are pre-order" note on the drawer's upsell trays (the card
    // script only paints them when a tray opens or a colour is tapped; the drawer's trays are born open)
    var box = q('[data-fst-recs]'); if (!box || typeof window.cpcRefreshSizes !== 'function') return;
    box.querySelectorAll('[data-cpc-qa]').forEach(function(qa){ try { window.cpcRefreshSizes(qa); } catch(e){} });
  }
  function hideRecsInCart(){
    // an upsell the shopper just added must not keep offering itself: hide rows whose product is now in the cart
    var box = q('[data-fst-recs]'); if (!box) return;
    paintRecChips();
    var inCart = {};
    document.querySelectorAll('#AjaxCartForm [data-js-cart-item][data-product-id]').forEach(function(el){ inCart[el.getAttribute('data-product-id')] = 1; });
    box.querySelectorAll('.fst-rec[data-product-id]').forEach(function(r){ r.hidden = !!inCart[r.getAttribute('data-product-id')]; });
  }
  function loadRecs(){
    var box = q('[data-fst-recs]'); if (!box) return;
    var first = q('#AjaxCartForm [data-js-cart-item]:not(.cart-item--gift)');
    var pid = first ? first.getAttribute('data-product-id') : '';
    if (!pid) return;  // empty cart: whatever is there stays (hidden by the empty state), the PDP prefetch included
    // keep the current set while the product it was built for is still in the cart
    if (recsFor && box.children.length && (recsFor === pid || q('#AjaxCartForm [data-js-cart-item][data-product-id="' + recsFor + '"]'))){ hideRecsInCart(); return; }
    fetchRecs(pid);
  }

  // upsell row: a color tap re-prices that row from its variants JSON (the server rendered the first color)
  document.addEventListener('cpc:color', function(e){
    var row = e.target && e.target.closest ? e.target.closest('.fst-rec') : null; if (!row) return;
    var qa = row.querySelector('[data-cpc-qa]'), pe = row.querySelector('.fst-rec__price'); if (!qa || !pe) return;
    var data = [], smap = {};
    try { data = JSON.parse(qa.querySelector('[data-cpc-variants]').textContent); } catch(err){}
    try { smap = JSON.parse((row.querySelector('[data-fst-rec-sale]') || { textContent: '{}' }).textContent); } catch(err){}
    var cpos = +qa.getAttribute('data-cpc-cpos') || 0, color = qa.getAttribute('data-cpc-color');
    var same = data.filter(function(x){ return !cpos || x['o' + cpos] === color; });
    var v = same.filter(function(x){ return x.av; })[0] || same[0];
    if (!v || typeof v.p !== 'number') return;
    var cur = pe.querySelector('b'), t = cur ? cur.textContent.trim() : '', m = t.match(/^(\D*)([\d,]+\.?\d*)(.*)$/);
    function money(c){ var s = (c / 100).toFixed(2); return m ? (m[1] + s + m[3]) : ('$' + s); }
    if (smap[String(v.id)]){
      var pay = Math.round(v.p * (100 - (parseFloat(smap._pct) || 20)) / 100);
      pe.innerHTML = '<span class="fst-sale-price"><del>' + money(v.p) + '</del> <b>' + money(pay) + '</b></span><span class="fst-rec__sale">' + (smap._label || 'On sale') + '</span>';
    } else {
      pe.innerHTML = (v.cp > v.p ? '<del>' + money(v.cp) + '</del>' : '') + '<b>' + money(v.p) + '</b>';
    }
  });

  // ---- ship-today cue (US, in-stock carts): mirrors snippets/cro-urgency.liquid (2pm ET cutoff + warehouse-closed days) ----
  var HOLIDAYS = { '2026-09-07': 1, '2026-11-26': 1, '2026-11-27': 1, '2026-12-25': 1, '2027-01-01': 1 };
  function etNow(){ try { var d = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York' })); return isNaN(d.getTime()) ? null : d; } catch(e){ return null; } }
  function isHoliday(d){ var m = d.getMonth() + 1, dd = d.getDate(); return !!HOLIDAYS[d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (dd < 10 ? '0' : '') + dd]; }
  function isBiz(d){ var w = d.getDay(); return w !== 0 && w !== 6 && !isHoliday(d); }
  function addBiz(date, n){ var d = new Date(date.getTime()), a = 0; while (a < n){ d.setDate(d.getDate() + 1); if (isBiz(d)) a++; } return d; }
  function paintShip(){
    // r7: the ship date lives in ONE place, the sub-line under CHECKOUT (US in-stock carts only; the server marks it).
    // Scoped to the cart: snippets/cro-shipping-cost.liquid uses similar data-fst-ship hooks on product pages.
    var cs = q('#site-cart-sidebar [data-fst-co-sub-ship], .fst-cart-page [data-fst-co-sub-ship]'); if (!cs) return;
    var et = etNow(); if (!et) return;
    var cutoffH = parseInt(cs.getAttribute('data-cutoff'), 10) || 14;
    var mins = et.getHours() * 60 + et.getMinutes();
    var today = isBiz(et) && mins < cutoffH * 60;
    var sub = today ? 'SHIPS TODAY' : 'SHIPS ' + addBiz(et, 1).toLocaleDateString('en-US', { weekday: 'long' }).toUpperCase();
    if (cs.textContent !== sub) cs.textContent = sub;
  }

  // ---- geometry guard (r10): on phones the drawer must span the screen after every render. Caleb's iPhone showed it
  // 27px narrow and right-anchored once after a Remove (the theme sizes .sidebar from a :root --sidebar-width it rewrites
  // on resize, and animates .sidebar__container width + .sidebar__content transform). CSS forces full bleed; this snaps
  // any drift back and clears a stray horizontal scroll of the content.
  function guardGeometry(){
    var d = drawer(); if (!d) return;
    var c = d.querySelector('.sidebar__content'); if (c && c.scrollLeft) c.scrollLeft = 0;
    if (window.innerWidth > 520 || !d.classList.contains('sidebar--opened')) return;
    var w = d.getBoundingClientRect().width, cw = c ? c.getBoundingClientRect().width : w;
    if (Math.abs(w - window.innerWidth) > 1 || Math.abs(cw - window.innerWidth) > 1){
      d.style.left = '0'; d.style.right = '0'; d.style.width = '100%';
      var k = d.querySelector('.sidebar__container'); if (k) k.style.width = '100%';
      if (c){ c.style.width = '100%'; }
    }
  }
  // ---- one signal for everything: the cart got re-rendered ----
  var timer = null, lastScroll = 0;
  document.addEventListener('scroll', function(e){ var sc = scroller(); if (sc && e.target === sc) lastScroll = sc.scrollTop; }, true);
  function onCartRender(){
    clearTimeout(timer);
    // a re-render that collapsed the scroll offset to 0 while the shopper was further down: put it back
    var sc0 = scroller();
    if (sc0 && lastScroll > 0 && sc0.scrollTop === 0 && sc0.scrollHeight - sc0.clientHeight >= lastScroll) sc0.scrollTop = lastScroll;
    timer = setTimeout(function(){
      var d = drawer(); if (d) d.classList.remove('is-adding');
      syncBadges(); giftEngine(); feeCleanup(); loadRecs(); paintShip(); guardGeometry(); fire(subs.loaded);
      setTimeout(guardGeometry, 450);
    }, 40);
  }
  function boot(){
    // The theme's sidebar-drawer show()/hide() iterate window.inertElems unguarded; with the stock header
    // section disabled (cro-header replaced it) nothing defines it, so define it here: everything outside
    // the drawers gets `inert` while a drawer is open (correct a11y behaviour, and no TypeError).
    if (!window.inertElems){
      // Same definition the theme's (now disabled) header used: only the elements it marked, never a
      // wrapper the drawers live inside, or the drawer would inert itself.
      window.inertElems = document.querySelectorAll('[data-js-inert]');
    }
    var af = document.getElementById('AjaxCartForm');
    if (af && window.MutationObserver) new MutationObserver(onCartRender).observe(af, { childList: true, subtree: true });
    if (!drawer()) mountExpress();  // the /cart page renders its wallet buttons through the same template
    var d = drawer();
    if (d && window.MutationObserver){
      new MutationObserver(function(){ if (d.classList.contains('sidebar--opened')){ mountExpress(); fire(subs.opened); if (fitExpress.refit){ setTimeout(fitExpress.refit, 350); setTimeout(fitExpress.refit, 1500); } } }).observe(d, { attributes: true, attributeFilter: ['class'] });
      if (d.classList.contains('sidebar--opened')) mountExpress();
    }
    // other scripts' generic cart events (bundle, sticky ATC, welcome flag) -> re-render silently.
    // Ignored while a refresh is in flight and for 1.2s after one lands: every event another script fires
    // in REACTION to our refresh arrives inside that window, so nothing can ping-pong (this exact loop
    // produced 27k requests and 429s on the dev theme before the guard existed).
    ['cart:refresh', 'cart:build', 'cart:updated', 'cart:added'].forEach(function(ev){
      document.addEventListener(ev, function(e){
        if (e && e.detail && e.detail.fst) return;
        if (inflight || (Date.now() - lastRefresh) < 1200) return;
        silentRefresh();
      });
    });
    // optimistic open: any ajax product-form submit (PDP buy box, sticky bar) and the card quick-add
    document.addEventListener('submit', function(e){
      var f = e.target; if (!f || !f.closest || !f.closest('product-form[data-ajax-cart]')) return;
      showDrawer(true);
    }, true);
    document.addEventListener('fst:adding', function(){ showDrawer(true); });
    // product page: have "Pair it with" ready before the first add
    var pm = window.meta && window.meta.product && window.meta.product.id;
    if (pm && !q('#AjaxCartForm [data-js-cart-item]:not(.cart-item--gift)')) fetchRecs(String(pm));
    // back/forward cache restore: the server-rendered drawer may be stale, re-render it once
    window.addEventListener('pageshow', function(e){ if (e.persisted) silentRefresh(); });
    setInterval(paintShip, 60000);  // the countdown ticks by the minute; no requests
    onCartRender();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
